import React, { HTMLAttributes } from 'react';

import cn from 'clsx';

import InputSizes from '../InputSizes';

function getGridClassNames(param: ColSizes | number) {
  const classNames = [];
  if (typeof param === 'object') {
    Object.entries(param).forEach(([size, val]) => {
      classNames.push(`col-${size}-${val}`);
    });
  } else {
    classNames.push(`col-sm-${param}`);
  }

  return classNames.join(' ');
}

function Div({ children, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div {...rest}>{children}</div>;
}

type RowColWidth =
  | number
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '7'
  | '8'
  | '9'
  | '10'
  | '11'
  | '12'
  | 'auto';
type RowColumns =
  | RowColWidth
  | {
      cols?: RowColWidth;
    };

interface ColSizes {
  xs?: RowColumns;
  sm?: RowColumns;
  md?: RowColumns;
  lg?: RowColumns;
  xl?: RowColumns;
  xxl?: RowColumns;
}

interface IInputWrapperProps {
  id: string;
  children: React.ReactNode;
  label?: React.ReactNode;
  message?: React.ReactNode;
  labelClassName?: string;
  wrapperClassName?: string;
  size?: InputSizes;
  labelGrid?: ColSizes | number;
  inputGrid?: ColSizes | number;
  horizontal?: boolean;
}

const InputWrapper: React.FC<IInputWrapperProps> = ({
  id,
  children,
  size,
  label,
  message,
  horizontal = false,
  labelGrid = 2,
  inputGrid = 10,
  labelClassName,
  wrapperClassName,
}) => {
  const InputContainer = horizontal ? Div : React.Fragment;
  const containerProps = horizontal
    ? { className: cn(horizontal && getGridClassNames(inputGrid)) }
    : {};

  const FormGroup = label ? Div : React.Fragment;
  const fgProps = label
    ? { className: cn('form-group', { row: horizontal }, wrapperClassName) }
    : {};

  return (
    <FormGroup {...fgProps}>
      {label && (
        <label
          htmlFor={id}
          className={cn(
            {
              'col-form-label-lg': size === InputSizes.Large,
              'col-form-label-sm': size === InputSizes.Small,
            },
            {
              'col-form-label': horizontal,
            },
            horizontal && getGridClassNames(labelGrid),
            labelClassName,
          )}
          style={{ margin: 0, lineHeight: 1.2 }}
        >
          {label}
        </label>
      )}
      <InputContainer {...containerProps}>
        <div className="d-flex">{children}</div>
        {message && <small className="form-text text-muted">{message}</small>}
      </InputContainer>
    </FormGroup>
  );
};

export default InputWrapper;
